import { useContext, useEffect, useRef, useState } from "react";
import { BefRpcContext, BefPageServiceContext, BefPageControllerContext, BefPageContainer, BefGlobalContext, BefGuid, BefMessageServiceContext } from "@beflam/bef-core";
import ReactRenderer from '../renderer/factory';
// import { loadComponentsAsync } from '../renderer/utils/loader'
// import fusionPackages from './fusion-package'
// import allcomponents from "./allcomponents";
import { BefQueryContainer } from "./BefQueryContainer";
import { LibraryManager } from "../assets";
import { BefPluginServiceContext } from "../service/bef-plugin-service.provider";
import { BefPluginProxyDataService } from "../service/bef-plugin-proxy-data-service";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Dialog } from "@alifd/next";
import { ExcelImport } from "./ExcelImport";
import { BefIssueList } from "@beflam/bef-issue";
import { DetailedCellError, HyperFormula } from "hyperformula";

export function Page(props: any) {

    const befRpc = useContext(BefRpcContext);
    const pageService = useContext(BefPageServiceContext);
    const [renderData, setRenderData] = useState<any>(null);
    const pageController = useContext(BefPageControllerContext);
    const sGlobal = useContext(BefGlobalContext);
    const pluginService = useContext(BefPluginServiceContext);
    const [isOpenQueryPage, setIsOpenQueryPage] = useState(false);
    const [isExcelImport, setIsExcelImport] = useState(false);
    const [isDialogIssue, setIsDialogIssue] = useState(false);
    const [issueParams, setIssueParams] = useState<{ [key: string]: any }>({});
    const [excelImortParams, setExcelImportParams] = useState({});
    const messageService = useContext(BefMessageServiceContext);
    const importExcelResolve = useRef<{ resolve: (value: any) => void, reject: (reason?: any) => void }>();
    const formula = useRef<HyperFormula>();
    const [formulaId, setFormulaId] = useState(0);

    // const getComponentsMap = async () => {
    //     let ComponentMap: Record<string, any> = (window as any)['ComponentMap'];
    //     if (!ComponentMap) {
    //         ComponentMap = await loadComponentsAsync(allcomponents, fusionPackages.packages);
    //         (window as any)['ComponentMap'] = ComponentMap;
    //     }
    //     return ComponentMap;
    // }
    const registerPagecChat = (pageServiceAny: any) => {
        pageServiceAny.page.onAction("pagechat", async (params: any) => {
            if (pageServiceAny.proxyService.chatEvent) {
                if (pageServiceAny.proxyService.chatEvent.constructor.name === 'AsyncFunction')
                    await pageServiceAny.proxyService.chatEvent(params);
                else
                    pageServiceAny.proxyService.chatEvent(params);
            }
        });
    };
    const showRenderSchema = async (renderSchema: any) => {
        const { componentsTree, i18n } = renderSchema.ChildrenSchema;
        const dataSourceData = renderSchema.DataSourceData
        const pageSchema = componentsTree[0];
        const ComponentMap = LibraryManager.components// await getComponentsMap();

        //pageService.page.appID = props.page.appID;
        pageService.renderSchema = renderSchema;
        pageService.page.pageTitle = renderSchema.Desc;
        pageService.apiHost = renderSchema.ApiHost;
        if (befRpc.rpcProxyId) {
            pageService.createContext(renderSchema.Script, pluginService.createPageProxy());
        } else {
            pageService.createContext(renderSchema.Script);
        }
        //这里pageService的context即为源代码，pageService.proxyService为page，目前excel的导出暂在这里注册
        const pageServiceAny = (pageService as any);
        pageServiceAny.proxyService.exportExcel = exportExcel;
        pageServiceAny.proxyService.importExcel = importExcel;
        pageServiceAny.proxyService.showIssue = showIssue;
        //这里添加公式计算的方法是为了也可以在SourceCode中使用
        pageServiceAny.proxyService.caculateFormula = caculateFormula;
        props?.onPageServiceChanged(pageService);

        setRenderData({ pageSchema, ComponentMap, i18n, dataSourceData, permissionControls: renderSchema.PermissionControls });
        if (befRpc.rpcProxyId && BefPluginProxyDataService.isProxy()) BefPluginProxyDataService.notifyOnPageLoad();

        registerPagecChat(pageServiceAny);
    }

    useEffect(() => {
        try {
            pageService.page = props.page;
            if (befRpc.rpcProxyId) {
                (pageService.page as any)["pluginParamSaveEvent"] = (result: any) => {
                    if (pageService.context) {
                        if (pageService.context.SaveParameter) {
                            return pageService.context.SaveParameter();
                        } else if ((pageService.page as any)["pluginParamSaveEventEx"]) {
                            return (pageService.page as any)["pluginParamSaveEventEx"]();
                        }
                    }
                    throw "缺少 plugin.saveParameter 方法";
                }
            }
            setIsOpenQueryPage(props.page.isQueryPage);
            pageService.isOpenQueryPage = props.page.isQueryPage;
            pageService.isCollapse = props.page.isCollapse;
            //如果存在renderSchema，那么直接使用renderSchema即可
            if (pageService.page.renderSchema) {
                showRenderSchema(pageService.page.renderSchema);
            } else {
                let pluginPageRenderSchema;
                if (befRpc.rpcProxyId) pluginPageRenderSchema = BefPluginProxyDataService.getPluginPageRenderSchema(props.page.pageID, props.page.state);
                if (pluginPageRenderSchema == null) {
                    befRpc.callRpc(pageService.page.appID, '', 'Beflam.Framework.Service.PageGroup.PageGroupService', 'GetPageDataEx', { appID: props.page.appID, pageGroupName: props.page.pageID, pageName: props.page.state }).subscribe(
                        async (res: any) => {
                            if (res.ViewData) {
                                pageService.setPageView(res.ViewData);
                            }
                            pageController.pageContainers?.forEach((container: BefPageContainer) => {
                                if (container.id === (pageService.page.appID + pageService.page.pageID + pageService.page.state)) {
                                    container.title = res?.Desc;
                                    sGlobal.afterPageShow.emit();
                                }
                            });
                            showRenderSchema(res);
                        },
                        (err) => {
                            messageService.showMessage(messageService.handleErr(err, "GetPageData"));
                            pageService.close();
                        }
                    );
                } else {
                    pluginPageRenderSchema.ApiHost = sGlobal.config.devApiHost;
                    showRenderSchema(pluginPageRenderSchema);
                }
            }

            //注册公式服务
            if (!formula.current) {
                formula.current = HyperFormula.buildEmpty({
                    licenseKey: "gpl-v3",
                    dateFormats: ["YYYY/MM/DD", 'DD/MM/YYYY', 'DD/MM/YY']
                });
                const sheetName = formula.current.addSheet(props.page.pageID || 'sheet1');
                const sheetId = formula.current.getSheetId(sheetName);
                setFormulaId(sheetId!);
            }
        } catch (err) {
            messageService.showMessage(messageService.handleErr(err, "GetPageData"));
            pageService.close();
        }
        // 组件卸载时清理
        return () => {
            formula.current?.destroy?.();
        };
    }, []);

    const caculateFormula = (state: any, formulas: { field: string, formula: string }[]): any => {
        if (!formula.current) return null;
        const hf = formula.current;
        clearAllNamedExpressions();
        //获取state的所有数据，然后设置到对应的单元格中
        for (const key in state) {
            if (Object.prototype.hasOwnProperty.call(state, key)) {
                const value = state[key];
                //只处理基本类型，不处理对象类型
                if (typeof value !== 'object') {
                    hf.addNamedExpression(key, value);
                }
            }
        }
        //遍历设置公式值
        formulas.forEach(item => {
            hf.setCellContents({ sheet: formulaId!, col: 0, row: 0 }, item.formula);
            const cellValue = hf.getCellValue({ sheet: formulaId!, col: 0, row: 0 });
            //如果公式错误，就设置为null值，同时在控制台打印错误信息
            //主要是不解析公式，因为比如在新增的时候，可能一些值缺失
            //也没办法设置默认值，因为不知道值类型，所以就统一为null
            if (cellValue instanceof DetailedCellError) {
                console.log(`Formula error in field ${item.field}: ${cellValue.value} ${cellValue.message}`);
                state[item.field] = null;
            } else {
                state[item.field] = cellValue;
            }
        });
        return state;
    };

    const clearAllNamedExpressions = () => {
        if (!formula.current) return;
        const allExpressions = formula.current.listNamedExpressions();
        allExpressions.forEach(name => {
            formula.current!.removeNamedExpression(name);
        });
    };

    async function exportExcel(data: any) {
        const pageServiceAny = (pageService as any);
        let rows: any[] = [];
        let columns: Array<Partial<ExcelJS.Column>> | null = null;
        let sheetName = 'Sheet1';
        let fileName = null;
        if (data) {
            if (Array.isArray(data)) {
                rows = data;
            } else {
                if (data.columns) {
                    columns = data.columns;
                }
                if (data.rows) {
                    rows = data.rows;
                }
                if (data.sheetName) sheetName = data.sheetName;
                if (data.fileName) fileName = data.fileName;

                if (data.convertFields) {
                    //这里需要对行数据进行转换
                    for (let row of rows) {
                        for (let cellKey in row) {
                            let convertCell = data.convertFields[cellKey];
                            if (convertCell) {
                                let cellValue = row[cellKey];
                                if (convertCell[cellValue]) row[cellKey] = convertCell[cellValue];
                            }
                        }
                    }
                }
            }
        }
        //如果data是数组的话，那么就是直接导出的数据，否则的话就是结构，结构中的数据允许设置转换字段
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sheetName);
        //如果列是空的，那么从数据中获取
        if ((!columns || columns.length <= 0) && rows.length > 0) {
            let firstRow = rows[0] as any;
            columns = [];
            for (var rowKey in firstRow) {
                //这里要获取语言
                columns.push({ header: pageServiceAny.proxyService.getLanguage(rowKey), key: rowKey });
            }
        }
        worksheet.columns = columns!;
        worksheet.addRows(rows);
        if (!fileName) fileName = BefGuid.newNGuid();

        const buffer = await workbook.xlsx.writeBuffer();
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const fileExtension = '.xlsx';
        const blob = new Blob([buffer], { type: fileType });
        saveAs(blob, fileName + fileExtension);
    }

    function importExcel(data: any) {
        return new Promise((resolve, reject) => {
            try {
                //这里直接显示上传界面即可
                setIsExcelImport(true);
                //data包含了dataAdapter的定义，会自动调用dataAdapter进行处理
                setExcelImportParams(data);
                importExcelResolve.current = { resolve, reject };
            } catch (err) {
                reject(err);
            }
        });
    }

    function importExcelDialogOnClose() {
        setIsExcelImport(false);
    }

    function showIssue(params: { [key: string]: any }) {
        //这里需要key和keyId
        if (!params || !params.key || !params.keyId) throw "缺少必要的参数 key 或 keyId";
        // 这里复制params的参数到setIssueParams中
        setIssueParams({ ...params });
        setIsDialogIssue(true);
    }

    function closeIssueDialog() {
        setIsDialogIssue(false);
    }

    return (
        <>
            {isOpenQueryPage && <BefQueryContainer></BefQueryContainer>}
            {renderData && <ReactRenderer
                className="lowcode-plugin-sample-preview-content"
                schema={renderData.pageSchema as any}
                components={renderData.ComponentMap}
                eventHandlers={pageService.context}
                dataSourceData={renderData.dataSourceData}
                permissionControls={renderData.permissionControls}
                messages={renderData.i18n}
                state={pageService.context}
                locale={sGlobal?.session?.lang}
            />}
            <Dialog
                v2
                title="Excel Import"
                visible={isExcelImport}
                footerActions={[]}
                closeMode={['close', 'esc']}
                onClose={importExcelDialogOnClose}
                width={650}
            >
                <ExcelImport importParams={excelImortParams} onClose={(result: any) => {
                    importExcelDialogOnClose();
                    importExcelResolve.current?.resolve?.(result);
                    importExcelResolve.current = undefined;
                }}></ExcelImport>
            </Dialog>
            <Dialog
                v2
                title="Issue List"
                visible={isDialogIssue}
                footerActions={[]}
                closeMode={['close', 'esc']}
                onClose={closeIssueDialog}
                width={'70%'}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <BefIssueList
                        style={{ flex: 1, height: '70vh' }}
                        info={{
                            appId: sGlobal.session.appId,
                            sessionId: sGlobal.session.id,
                            key: issueParams.key,
                            keyId: issueParams.keyId,
                            host: sGlobal.config.host,
                            author: sGlobal.session.userId,
                        }}
                    />
                </div>
            </Dialog>
        </>
    );
}
